<template>
    <md-content class="card md-layout-item md-size-100 md-small-size-100">
        <div class="md-flex-center-center md-form-input md-relative">
            <h1 class="md-title md-form-title">{{ $t('views.admin.configurations.contractSign.title') }}</h1>
            <md-card class="md-form-card md-mt-70">
                <div>
                  <form novalidate class="md-layout-item md-size-100 md-small-size-100">
                      <div class="md-layout-item md-small-size-100">
                        <md-field :class="getValidationClass('agencyId')">
                          <label for="agency">{{ $t('views.admin.configurations.contractSign.agency') }}</label>
                          <SelectWithFilter :list="agencies" @input="pickAgency" v-model="$v.form.agencyId.$model"
                                            :name="`agency`" :id="`agency`"
                                            v-slot="{item}">
                            <md-option :value="item.valueId">{{ item.name }}</md-option>
                          </SelectWithFilter>
                          <span class="md-error" v-if="!$v.form.agencyId.required">{{ $t('validation.required') }}</span>
                          <server-error v-else field-name="agencyId" :server-errors="serverErrors" />
                        </md-field>
                      </div>

                    <div class="md-bg-form">
                      <slide-y-down-transition :duration="{enter: 500, leave: 0}">
                        <div class="md-pd-16">
                          <md-table v-model="contractSign.groups" md-model-id="index" v-if="contractSign.groups.length > 0">
                            <md-table-toolbar class="md-p0">
                              <div class="md-toolbar-section-start">
                                <h1 class="md-title md-m0">
                                  {{ $t('views.admin.configurations.contractSign.groups.title') }}
                                </h1>
                              </div>
                              <div class="md-toolbar-section-end" v-if="!showAddContractSignGroupForm && hasAccess('PRIVILEGE_CONFIGURATION_CONTRACT_SIGN_GROUP')">
                                <div v-if="id && !view">
                                  <md-button class="md-subtitle-btn"
                                             @click="showAddContractSignGroupForm = false">
                                    {{ $t('views.admin.configurations.contractSign.add.label') }}
                                  </md-button>
                                </div>
                                <div v-if="!id && !view">
                                  <md-button class="md-subtitle-btn "
                                             @click="showAddContractSignGroupForm = true">
                                    {{ $t('views.admin.configurations.contractSign.add.label') }}
                                  </md-button>
                                </div>
                              </div>
</md-table-toolbar>
                            <md-table-row slot="md-table-row" slot-scope="{ item, index }"
                                          :md-id="item.name+index">
                              <template v-if="!item.type">
                                <md-table-cell
                                    :md-label="$t('views.admin.configurations.contractSign.groupTable.id')">
                                  {{ index +1 }}
                                </md-table-cell>
                                <md-table-cell
                                    :md-label="$t('views.admin.configurations.contractSign.groupTable.name')">
                                  {{ item.name }}
                                </md-table-cell>
                                <md-table-cell
                                  :md-label="$t('views.admin.configurations.contractSign.groupTable.requiredSignatures')">
                                {{ item.requiredSignatures }}
                                </md-table-cell>
                              <md-table-cell
                                  :md-label="$t('views.admin.configurations.contractSign.groupTable.limit')">
                                {{ formatLocaleNumber(item.limit) }}
                              </md-table-cell>
                              <md-table-cell
                                  :md-label="$t('views.admin.configurations.contractSign.groupTable.monthlyLimit')">
                                {{ formatLocaleNumber(item.monthlyLimit) }}
                              </md-table-cell>
                                <md-table-cell
                                    :md-label="$t('views.admin.configurations.contractSign.groupTable.actions')">
                                  <md-button class="md-icon-button"
                                             v-if-has-access="['PRIVILEGE_CONTRACT_SIGN_GROUP_USERS_MANAGEMENT']"
                                             @click="addUsersToContractSignGroup(item,index)"
                                             v-if="!view">
                                    <md-tooltip md-direction="top">
{{ $t('views.admin.configurations.contractSign.groupTable.users') }}
                                    </md-tooltip>
                                    <md-icon>assignment_ind</md-icon>
                                  </md-button>
                                  <md-button v-if="!view"
                                             v-if-has-access="['PRIVILEGE_CONFIGURATION_CONTRACT_SIGN_GROUP']"
                                             class="md-icon-button"
                                             @click="showDetails(item, index)">
                                    <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
                                    <md-icon>description</md-icon>
                                  </md-button>
                                  <md-button class="md-icon-button"
                                             v-if-has-access="['PRIVILEGE_CONFIGURATION_CONTRACT_SIGN_GROUP']"
                                             @click="deleteContractSignGroup( { ...item, index: index } )"
                                             v-if="!view">
                                    <md-tooltip md-direction="top">
{{ $t('delete') }}
                                    </md-tooltip>
                                    <md-icon>delete</md-icon>
                                  </md-button>
                                </md-table-cell>
                              </template>
                              <template v-else-if="item.type==='Details'">
                                <td colspan="7">
                                  <ContractSignGroupForm @add="addContractSignGroup" @edit="editContractSignGroup" :id="item.id" :item="item"
                                                         :index="index" />
                                </td>
                              </template>
                              <template v-else-if="item.type==='Users'">
                                <td colspan="7">
                                  <UsersContractSignGroupForm :id="item.id" :item="item"
                                                         :index="index" @users="addUserToContractSignGroup" />
                                </td>
                              </template>
                            </md-table-row>
                          </md-table>
                        <div class="noDataForTable" v-if="contractSign.groups.length === 0">
                          <div class="buttonBox">
                            <div class="md-toolbar-section-end" v-if="!showAddContractSignGroupForm">
                              <div v-if="id && !view">
                                <md-button class="md-subtitle-btn"
                                           @click="showAddContractSignGroupForm = false">
                                  {{ $t('views.admin.configurations.contractSign.add.label') }}
                                </md-button>
                              </div>
                              <div v-if="!id && !view">
                                <md-button class="md-subtitle-btn "
                                           @click="showAddContractSignGroupForm = true">
                                  {{ $t('views.admin.configurations.contractSign.add.label') }}
                                </md-button>
                              </div>
                            </div>
                          </div>
                          <div class="noDataDialogBox">
                          <span>{{ $t('dialog.noData') }}</span>
                          </div>
                        </div>
                        </div>
                      </slide-y-down-transition>
                      <slide-y-up-transition>
                        <div v-if="showAddContractSignGroupForm">
                          <ContractSignGroupForm @add="addContractSignGroup" @edit="editContractSignGroup" :contract-groups="contractSign.groups" :groups="contractSign.groups"
                                                 :agency="agencyId" />
                        </div>
                      </slide-y-up-transition>
                    </div>
                   </form>
                </div>
            </md-card>
        </div>
    </md-content>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {agenciesEndpoint, configurationsEndpoint} from '@/services/adsign-backend/endpoints';
  import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
  import store from "@/store";
  import SelectWithFilter from '@/components/SelectWithFilter';
  import ServerError from "@/components/ServerError";
  import {required} from "vuelidate/lib/validators";
  import {SlideYDownTransition, SlideYUpTransition} from 'vue2-transitions';
  import ContractSignGroupForm from "@/views/admin/configuration/contractSign/ContractSignGroupForm";
  import UsersContractSignGroupForm from "@/views/admin/configuration/contractSign/UsersContractSignGroupForm";
  import {hasAccess} from "@/utils/jwtUtils";
  import orderCommons from '@/mixins/orderCommons';

  export default {
    components: {SelectWithFilter,ServerError,SlideYUpTransition, SlideYDownTransition,ContractSignGroupForm,UsersContractSignGroupForm},

    name: 'ContractSignGroupList',
    mixins: [serverSideValidationErrors,orderCommons],
    props: {
      id: {
        type: String,
        default: undefined
      },
      view: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        showAddContractSignGroupForm: false,
        showAddUsersSignGroupForm: false,
        agencies: [],
        agencyId:null,
        contractSign:{
          groups: [],
        },
        form: {
          agencyId: this.value?.agencyId
        }
      }},
    computed: {
      ...mapGetters('auth', ['hasAccess']),
      add: {
        get() {
          return this.id === undefined;
        }
      }
    },
    validations: {
      form:{
        agencyId: {
          required
        }
      }
    },
    mounted() {
      if(this.hasAccess('PRIVILEGE_CONFIGURATION_CONTRACT_SIGN_GROUP')){
        this.loadAgencies('PRIVILEGE_CONFIGURATION_CONTRACT_SIGN_GROUP');
      }else{
        this.loadAgencies('PRIVILEGE_CONTRACT_SIGN_GROUP_USERS_MANAGEMENT');
      }
    },
    methods: {
      loadAgencies(privilege) {
        agenciesEndpoint.getAgencies(privilege).then(result => {
          this.agencies = result.data.sort((a, b) => a.name < b.name ? -1 : 1)
          if(result.data.length === 1){
            store.commit('misc/AGENCY_ID', result.data[0].id)
            this.$v.form.agencyId.$model = result.data[0].id
          }
        });

      },
      pickAgency(id) {
        store.commit('misc/AGENCY_ID', id)
        this.form.agencyId = id
        configurationsEndpoint.getContractSignGroupsForAgency(id).then(result=>{
          this.contractSign.groups = result.data;
          this.agencyId = id;
        })
      },
      showDetails(item, index) {
        if (this.removeDetailsRow(index + 1)) {
          return;
        }
        const contractSignGroupDetail = {
          id: item.id,
          name: item.name,
          agency: item.agency,
          limit:item.limit,
          monthlyLimit:item.monthlyLimit,
          requiredSignatures: item.requiredSignatures,
          contractSignGroups:item.contractSignGroups,
          signWithTheSameGroup:item.signWithTheSameGroup,

          type: 'Details',
          index: index,
          action: 'edit'
        };
        this.contractSign.groups.splice(index + 1, 0, contractSignGroupDetail);
      },
      addUsersToContractSignGroup(item, index){
        if (this.removeDetailsRow(index + 1)) {
          return;
        }
        const contractSignGroupDetail = {
          id: item.id,
          name: item.name,
          agency: item.agency,
          limit:item.limit,
          monthlyLimit:item.monthlyLimit,
          requiredSignatures: item.requiredSignatures,
          contractSignGroups:item.contractSignGroups,
          signWithTheSameGroup:item.signWithTheSameGroup,

          type: 'Users',
          index: index,
          action: 'edit'
        };

        this.contractSign.groups.splice(index + 1, 0, contractSignGroupDetail);
      },
      addContractSignGroup(group) {
        if (this.showAddContractSignGroupForm) {
          this.showAddContractSignGroupForm = false;
        }
        this.contractSign.groups.push(group);

      },
      addUserToContractSignGroup(group){
        this.removeDetailsRow(group.index);
      },
      editContractSignGroup(group) {
        if (this.showAddContractSignGroupForm) {
          this.showAddContractSignGroupForm = false;
          return;
        }
        if (group) {
          this.removeDetailsRow(group.index);
        }
        this.pickAgency(group.agency);
      },

      removeDetailsRow(index) {
        if (this.contractSign.groups[index] && this.contractSign.groups[index].type) {
          this.contractSign.groups.splice(index, 1);
          return true;
        }
      },

      deleteContractSignGroup(item) {
        if (item.index >= 0 && !item.id) {
          this.contractSign.groups.splice(item.index, 1);
          return;
        }
        configurationsEndpoint.deleteContractSignGroup(item.id)
        .then((response) => {
          this.pickAgency(this.agencyId);
        })
        .catch(this.handleServerValidationError)
        .finally(() => {
              this.sending = false;
            }
        );
      },

    }
  }
</script>
<style lang="scss" scoped>
.noDataForTable{
  height: 300px;
  width: 100%;
  .noDataDialogBox,.buttonBox{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .noDataDialogBox{
    height: 200px;
  }
  .buttonBox{
    height: 100px;
  }
}
</style>
